export default "__VITE_ASSET__7K$9vUD4__"